import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { MATERIAL_ICONS } from 'app/constants/material-icons';

@Component({
  selector: 'app-modal-icon-picker',
  templateUrl: './modal-icon-picker.component.html',
  styleUrls: ['./modal-icon-picker.component.scss'],
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    TranslocoPipe,
  ],
})
export class ModalIconPickerComponent {
  dialogRef = inject(MatDialogRef<ModalIconPickerComponent>);
  data = inject<{ current: string | null }>(MAT_DIALOG_DATA);

  search = '';
  selected = signal<string | null>(this.data.current ?? null);

  get filtered(): string[] {
    const q = this.search.trim().toLowerCase();
    if (!q) {
      return MATERIAL_ICONS;
    }
    return MATERIAL_ICONS.filter((icon) => icon.includes(q));
  }

  select(icon: string): void {
    this.selected.set(icon === this.selected() ? null : icon);
  }

  confirm(): void {
    this.dialogRef.close({ selected: this.selected() });
  }

  clear(): void {
    this.dialogRef.close({ selected: null });
  }
}
